import { render } from "./advance-setting.vue?vue&type=template&id=a60edeaa&scoped=true&ts=true"
import script from "./advance-setting.vue?vue&type=script&lang=ts"
export * from "./advance-setting.vue?vue&type=script&lang=ts"

import "./advance-setting.vue?vue&type=style&index=0&id=a60edeaa&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60edeaa"]])

export default __exports__